export default __webpack_public_path__ + "static/media/alvamalia.81626b56.png";